import { H1 } from 'honorable'

// Home scene
function Home() {
  return (
    <>
      <H1 mb={2}>Hero Engineer home</H1>
    </>
  )
}

export default Home
